import { apiService } from "../../../services/apiService";
import { apiServiceConstants } from "../../../constants";
import { utilService } from "../../../services/utilService";

const handleErrorResponse = () => {};

const updateMessageReadStatus = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `user/update-message-media-seen/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

const removeMessageListItem = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `user/message-media-list/${params.id}/?type=${
        params.type
      }&reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.DELETE,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: true,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

export const setMessageListService = {
  handleErrorResponse,
  updateMessageReadStatus,
  removeMessageListItem,
};
